// extracted by mini-css-extract-plugin
export default {"podiumContainer":"Podium_podiumContainer__yQnF3","podiumStep":"Podium_podiumStep__u+SML","winnerName":"Podium_winnerName__MEebB"};